import { render } from "./ChamadaOrcamento.vue?vue&type=template&id=47249334&scoped=true&ts=true"
import script from "./ChamadaOrcamento.vue?vue&type=script&lang=ts"
export * from "./ChamadaOrcamento.vue?vue&type=script&lang=ts"

import "./ChamadaOrcamento.vue?vue&type=style&index=0&id=47249334&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47249334"]])

export default __exports__